// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"article-teasers_wrapper__dF1n_"};